import { render, staticRenderFns } from "./LuckyWheel.vue?vue&type=template&id=5946a795&scoped=true"
import script from "./LuckyWheel.vue?vue&type=script&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&lang=js"
import style0 from "./LuckyWheel.vue?vue&type=style&index=0&id=5946a795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946a795",
  null
  
)

export default component.exports